if (!customElements.get('shoev-source-story')) {
  customElements.define('shoev-source-story', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.diagramControls = Array.from(this.querySelectorAll('[data-workflow-control]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (nextIndex === undefined) return;
          event.preventDefault();
          this.activate(this.tabs[nextIndex], true);
        });
      });
      this.diagramControls.forEach((control) => {
        control.addEventListener('click', () => {
          const matchingTab = this.tabs.find((tab) => tab.dataset.workflowStep === control.dataset.workflowControl);
          if (matchingTab) this.activate(matchingTab);
        });
      });
    }

    activate(activeTab, focus = false) {
      const activeStep = activeTab.dataset.workflowStep;
      this.tabs.forEach((tab) => {
        const active = tab === activeTab;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== activeTab.getAttribute('aria-controls');
      });
      this.diagramControls.forEach((control) => {
        control.setAttribute('aria-pressed', String(control.dataset.workflowControl === activeStep));
      });
      this.dataset.active = activeStep;
      if (focus) activeTab.focus();
    }
  });
}

if (!customElements.get('shoev-product-video-rail')) {
  customElements.define('shoev-product-video-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.items = Array.from(this.querySelectorAll('[data-video-item]'));
      this.items.forEach((item) => this.setupItem(item));
      this.pauseFromAnotherRail = (event) => {
        if (event.detail?.source === this) return;
        this.pauseAll();
      };
      document.addEventListener('shoev:video-play', this.pauseFromAnotherRail);
    }

    disconnectedCallback() {
      document.removeEventListener('shoev:video-play', this.pauseFromAnotherRail);
    }

    pauseAll(except) {
      this.items.forEach((item) => {
        if (item === except) return;
        const video = item.querySelector('video');
        if (video && !video.paused) video.pause();
      });
    }

    setupItem(item) {
      const video = item.querySelector('video');
      const toggle = item.querySelector('[data-video-toggle]');
      const sound = item.querySelector('[data-video-sound]');
      const label = item.dataset.videoLabel || 'video';
      const playLabel = item.dataset.playLabel || 'Play';
      const pauseLabel = item.dataset.pauseLabel || 'Pause';
      const soundOnLabel = item.dataset.soundOnLabel || 'Turn sound on for';
      const soundOffLabel = item.dataset.soundOffLabel || 'Mute';
      if (!video || !toggle) return;

      const syncPlayback = () => {
        const playing = !video.paused && !video.ended;
        item.classList.toggle('is-playing', playing);
        toggle.setAttribute('aria-pressed', String(playing));
        toggle.setAttribute('aria-label', `${playing ? pauseLabel : playLabel} ${label}`);
        if (sound) {
          sound.disabled = !playing;
          sound.tabIndex = playing ? 0 : -1;
          sound.setAttribute('aria-hidden', String(!playing));
        }
      };

      const syncSound = () => {
        if (!sound) return;
        const muted = video.muted || video.volume === 0;
        sound.setAttribute('aria-pressed', String(muted));
        sound.setAttribute('aria-label', `${muted ? soundOnLabel : soundOffLabel} ${label}`);
      };

      toggle.addEventListener('click', () => {
        if (!video.paused && !video.ended) {
          video.pause();
          return;
        }
        this.pauseAll(item);
        document.dispatchEvent(new CustomEvent('shoev:video-play', { detail: { source: this } }));
        const rememberMuted = window.__shoevVideoMutedPreference === true;
        video.muted = rememberMuted;
        if (!rememberMuted && video.volume === 0) video.volume = 1;
        syncSound();
        const playback = video.play();
        if (playback?.catch) {
          playback.catch(() => {
            video.muted = true;
            syncSound();
            video.play().catch(syncPlayback);
          });
        }
      });

      sound?.addEventListener('click', () => {
        const muted = video.muted || video.volume === 0;
        if (muted && video.volume === 0) video.volume = 1;
        video.muted = !muted;
        window.__shoevVideoMutedPreference = video.muted;
        syncSound();
      });

      video.addEventListener('play', syncPlayback);
      video.addEventListener('pause', syncPlayback);
      video.addEventListener('ended', syncPlayback);
      video.addEventListener('volumechange', syncSound);
      syncPlayback();
      syncSound();
    }
  });
}
